<template>
  <div class="pa-7" id="summary">
   <!--タイトル-->
    <span class="subHead">
    {{ title }}
    </span>
    <v-icon
    class="mb-2"
    color="blue-grey darken-2">
      {{ icon }}
    </v-icon>

 <!--内容-->
<v-row>
<v-col  cols="12" xs="12" md="6" lg="6" xl="6">
 <v-card-text class="summary">
 {{ description }}
 </v-card-text>
</v-col>
<v-col  cols="12" xs="12" md="6" lg="6" xl="6">
 <v-img :src="src"></v-img>
</v-col>
</v-row>
<div style="text-align:center; color:#C62828; margin-top:3rem;">試用など各種ご相談お問い合わせは、こちらからお願いいたします。</div>
</div>
</template>

<style>
.subHead {
  font-size: 25px;
}
.head2 {
  font-size: 20px;
  border-left: inset 6px#99CCFF;
  padding-left: 8px;
  margin-bottom: 8px;
}
.summary {
  vertical-align: middle;
  font-size: 16px;
}
</style>

<script>
export default {
  data () {
    return {
      // タイトル
      title: '概要',
      // タイトル横のアイコン
      icon: 'mdi-message-bulleted',
      // 説明文
      description: '学術集会向け事前参加登録システムをご用意しています。同伴者の同時申し込み、懇親会等のオプションに応じて登録可能です。',
      // 画像
      src: require('../../assets/Products/participation.png')
    }
  }
}
</script>
